module.exports = __webpack_public_path__ + "static/media/Image Placeholder.079ddd69.png";